<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="row items-center q-pb-none">
      <div>
        {{ selectedCustomer.Cs_Name }}
      </div>
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>

    <q-card-section class="no-padding">
      <q-table
          :data="orderHistoryList"
          row-key="Sale_Num"
          wrap-cells
          :filter="filter"
          flat
          :pagination.sync="pagination">
        <template v-slot:header>
          <q-input filled label="جستجو در لیست" v-model="filter" class="q-pa-sm"/>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class" v-if="props.row.Sale_State === sale_state">
            <q-td>
              <q-card flat>
                <q-card-section class="no-padding">
                  <div class="row">
                    <div class="col-10">
                      <div class="row">
                        <div class="col">
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                  icon="qr_code">فاکتور ({{ props.row.Sale_Num }})
                          </q-chip>
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                  icon="qr_code">سفارش ({{ props.row.Order_Num }})
                          </q-chip>
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                  icon="qr_code">حواله ({{ props.row.Hava_Num }})
                          </q-chip>
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="red" icon="event" outline>تاریخ فاکتور
                            ({{ props.row.Sale_Date }})
                          </q-chip>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="purple" icon="functions"
                                  text-color="white">
                            {{ props.row.Sale_Count }} عدد
                          </q-chip>
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="green-14" icon="attach_money"
                                  text-color="white">
                            {{ props.row.Sale_Pay | toCurrency }} ریال
                          </q-chip>
                        </div>
                      </div>
                      <div class="row">
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">{{
                            props.row.CompName
                          }}
                        </q-chip>
                        <q-chip clickable :size="$q.screen.lt.md?'md':'md'" square icon="person"
                                @click="showCustomerInfo(props.row)">
                          {{ props.row.Cs_Name }}
                        </q-chip>
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="support_agent">
                          {{ props.row.UserName }}
                        </q-chip>
                      </div>
                    </div>
                  </div>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-banner rounded v-if="props.row.LastTraceinfo" dense
                            :class="props.row.LastTraceinfo==='حذف'?'bg-red-8 text-white':'bg-blue-8 text-white'"
                            row.Sale_Num>
                    {{ props.row.LastTraceinfo === 'حذف' ? 'لطفا از سیستم حذف گردد.' : props.row.LastTraceinfo }}
                    <div v-if="props.row.ReasonDescription && props.row.ReasonDescription!==props.row.LastTraceinfo">
                      <q-separator color="white"/>
                      {{ props.row.ReasonDescription }}
                    </div>
                  </q-banner>
                </q-card-section>
                <q-card-actions>
                  <q-btn round dense color="indigo" class="q-mb-xs" padding="none" size="lg" icon="info"
                         @click="showDetails(props.row)"/>
                  <q-btn v-if="props.row.Sale_State===0" flat padding="none" size="lg" round
                         color="positive" icon="check"
                         @click="setSaleState(props.row.Sale_Num)">
                    <q-tooltip>
                      تایید فاکتور
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat icon="timeline" color="indigo" @click="showOrderTimeLine(props.row)">
                    <q-tooltip>
                      رهگیری سفارش
                    </q-tooltip>
                  </q-btn>
                  <q-btn flat size="md" round
                         color="indigo"
                         icon="print"
                         @click="printfactor(props.row)">
                    <q-tooltip>
                      چاپ فاکتور
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="props.row.Sale_State===1 && props.row.Sale_StateModir===0 && $store.state.roles.some(v=>['admin','can_final_order'].includes(v))"
                      flat padding="none" size="lg" round class="q-mt-xs"
                      color="positive" icon="done_all"
                      @click="setFinalSaleState(props.row)">
                    <q-tooltip>
                      تایید نهایی فاکتور
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="$store.state.roles.some(v=>['admin','can_delete_factor'].includes(v))"
                      flat round class="q-mt-xs"
                      color="negative" icon="delete"
                      :disable="props.row.LastTraceinfo!=='حذف' || props.row.LastTraceinfo==='سند حسابداری زده شد'"
                      @click="deleteFactor(props.row)">
                    <q-tooltip>
                      حذف فاکتور
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      flat
                      round
                      color="deep-orange"
                      icon="assignment_return"
                      @click="showReturnOrderDialog(props.row)"
                      v-if="props.row.Sale_Kind===1  && $store.state.roles.some(v=>['admin','can_return_factor'].includes(v))">
                    <q-tooltip>
                      صدور سند برگشت
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="props.row.Sale_Kind===1 && props.row.Sale_PayReceive !== props.row.Sale_Pay && $store.state.roles.some(v=>['admin','can_save_receive_pay'].includes(v))"
                      flat
                      round
                      color="green"
                      icon="attach_money">
                    <q-tooltip>
                      ثبت رسید پرداخت
                    </q-tooltip>
                    <InvoiceSettlement :sale-num="parseInt(props.row.Sale_Num)"/>
                  </q-btn>
                </q-card-actions>
              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <factor-details :sale-state="selectedFactor.Sale_State" :sale-num="selectedSaleNum" :factor-items="factorItems"
                      :sale-kind="selectedFactor.Sale_Kind"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :sale-num="selectedSaleNum" :sale-date="selectedFactor.Sale_Date" @refresh-data="changeRow"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>

    <q-dialog maximized v-model="returnOrderDialog">
      <IssueReturnOrder :cs-i-d="selectedFactor.Cs_ID" :sale-num="selectedFactor.Sale_Num"
                        :hava-num="selectedFactor.Hava_Num" @refresh-data="closeReturnOrderDialog"/>
    </q-dialog>

    <q-dialog v-model="factorPrintDialog">
      <FactorPrintDialog :factor-info="selectedFactor" title="چاپ فاکتور"/>
    </q-dialog>

  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import FactorDetails from "@/components/Factor/FactorDetails";
import CustomerInfo from "@/components/customers/CustomerInfo";
import IssueReturnOrder from "@/components/Remittance/IssueReturnOrder";
import InvoiceSettlement from "@/components/Factor/InvoiceSettlement";
import FactorPrintDialog from "@/components/PrintDialogs/FactorPrintDialog.vue";

export default {
  name: "FactorCustomerHistory",
  components: {FactorPrintDialog, InvoiceSettlement, IssueReturnOrder, CustomerInfo, FactorDetails, OrderTimeLine},
  props: ['orderHistoryList', 'defaultSaleState', 'isDialog'],
  data() {
    return {
      factorPrintDialog:false,
      returnOrderDialog: false,
      selectedFactor: '',
      filter: '',
      selectedCustomer: '',
      customerInfoDialog: false,
      factorItems: [],
      showOrderDetailsDialog: false,
      showTimeLineDialog: false,
      selectedSaleNum: '',
      sale_state: false,
      pagination: {
        rowsPerPage: 10
      },
    }
  },
  methods: {
    ...mapActions({
      setSaleState: 'Orders/setSaleState',
      setFinalOrder: 'Orders/setSaleFinalState',
      getFactorItems: 'Orders/getFactorItems',
      getCustomerInfo: 'Customers/get_customer_info',
      deleteFactorBySaleNum: 'Orders/deleteFactor',

    }),
    deleteFactor(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از حذف فاکتور اطمینان دارید؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteFactorBySaleNum({
          saleNum: row.Sale_Num,
          saleKind: row.Sale_Kind
        }).then(() => {
          this.$q.notify({
            message: `فاکتور ${row.Sale_Num}حذف گردید گردید `,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
        })
      })
    },
    printfactor(item) {
      this.selectedFactor = item
      this.factorPrintDialog = true
    },
    showDetails(row) {
      this.getFactorItems({
        sale_num: row.Sale_Num,
        sale_kind: row.Sale_Kind
      }).then((res) => {
        this.factorItems = res;
        this.selectedFactor = row
        this.selectedSaleNum = row.Sale_Num;
        this.showOrderDetailsDialog = true;
      })
    },
    showCustomerInfo(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.customerInfoDialog = true;
      })
    },
    setFinalSaleState(row) {
      this.setFinalOrder(row.Sale_Num).then((res) => {
        if (res.data.msg === 'success') {
          this.$q.notify({
            message: `فاکتور ${row.Sale_Num}تایید گردید `,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          row.Sale_StateModir = 1
        }
      })
    },
    setSaleState(sale_num) {
      this.$q.dialog({
        title: 'تاییدیه نقد بودن خرید',
        message: 'آیا خرید طرف معامله نقدی می باشد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.setSaleState({
          sale_num: sale_num,
          cash: true
        }).then((res) => {
          if (res.data.msg === "success") {
            this.$q.notify({
              message: `فاکتور ${sale_num}نهایی گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }).catch(() => {
          this.$q.notify({
            message: 'طرف معامله اعتبار کافی ندارد',
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        });
      }).onCancel(() => {
        this.setSaleState({
          sale_num: sale_num,
          cash: false
        }).then((res) => {
          if (res.data.msg === "success") {
            this.$q.notify({
              message: `فاکتور ${sale_num}نهایی گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }).catch(() => {
          this.$q.notify({
            message: 'طرف معامله اعتبار کافی ندارد',
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        });
      }).onDismiss(() => {

      })
    },
    showOrderTimeLine(row) {
      this.selectedSaleNum = row.Order_Num;
      this.selectedFactor = row
      this.showTimeLineDialog = true;
    },
    showReturnOrderDialog(row) {
      if (row.LastTraceinfo !== 'برگشت سفارش') {
        this.$q.notify({
          message: 'به دلیل عدم ثبت برچسب برگشت سفارش امکان ثبت سند برگشت میسر نمی باشد',
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      } else {
        this.selectedFactor = row
        this.returnOrderDialog = true;
      }
    },
    closeReturnOrderDialog() {
      this.returnOrderDialog = false;
    },
    changeRow(arg) {
      let founded = this.orderHistoryList.filter(item => item.Order_Num === arg.data.Sale_Num)
      if (founded && founded.length > 0) {
        founded[0].LastTraceinfo = arg.data.title
        founded[0].ReasonDescription = arg.data.ReasonDescription
      }
    },
  },
  created() {
    if (this.defaultSaleState === undefined) {
      this.sale_state = 1

    } else {
      this.sale_state = this.defaultSaleState
    }
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
